/**
 * @typedef {(KNIGHT_DOWN_LEFT_LEFT | KNIGHT_DOWN_RIGHT_RIGHT | KNIGHT_UP_UP_LEFT | KNIGHT_UP_UP_RIGHT)} TypeCard A card.
 */

/**
 * The 'KNIGHT_DOWN_LEFT_LEFT' card.
 * @type {'KNIGHT_DOWN_LEFT_LEFT'}
 * @constant
 */
const KNIGHT_DOWN_LEFT_LEFT = 'KNIGHT_DOWN_LEFT_LEFT';

/**
 * The 'KNIGHT_DOWN_RIGHT_RIGHT' card.
 * @type {'KNIGHT_DOWN_RIGHT_RIGHT'}
 * @constant
 */
const KNIGHT_DOWN_RIGHT_RIGHT = 'KNIGHT_DOWN_RIGHT_RIGHT';

/**
 * The 'KNIGHT_UP_UP_LEFT' card.
 * @type {'KNIGHT_UP_UP_LEFT'}
 * @constant
 */
const KNIGHT_UP_UP_LEFT = 'KNIGHT_UP_UP_LEFT';

/**
 * The 'KNIGHT_UP_UP_RIGHT' card.
 * @type {'KNIGHT_UP_UP_RIGHT'}
 * @constant
 */
const KNIGHT_UP_UP_RIGHT = 'KNIGHT_UP_UP_RIGHT';

export {

    KNIGHT_DOWN_LEFT_LEFT,
    KNIGHT_DOWN_RIGHT_RIGHT,
    KNIGHT_UP_UP_LEFT,
    KNIGHT_UP_UP_RIGHT
};
